var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('span',{staticClass:"spinner-border spinner-border-lg",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }